import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { ResultsSection } from '../components/ResultsSection';
import { IncludesSection } from '../components/IncludesSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { PricingSection } from '../components/PricingSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#fdfbf7] font-sans selection:bg-[#dc4a3d] selection:text-white" data-id="element-189">
      <HeroSection data-id="element-190" />
      <ProblemSection data-id="element-191" />
      <MechanismSection data-id="element-192" />
      <ResultsSection data-id="element-193" />
      <IncludesSection data-id="element-194" />
      <ForWhoSection data-id="element-195" />
      <PricingSection data-id="element-196" />
      <ClosingSection data-id="element-197" />
      <Footer data-id="element-198" />
    </div>;
}